import React from 'react';
import Reflux from 'reflux';
import {DiaLogMapEditorsStore} from '../../stores/CommandStore';
import DialogValue from './remote/DialogValue';
import FormItemConst from '../../formItem/FormItemConst';

export default class DialogFieldLabel extends React.Component
{
	lookupStates = 
	{
		isShowed:false
	}

	constructor(props)
	{
		super(props);
		this.state = {data:this.props.data};
		this.unsubscribeDiaLogMapEditorsStore = DiaLogMapEditorsStore.listen(this.onDiaLogMapEditors.bind(this));
	}

	onDiaLogMapEditors(dialogId,result)
	{
		if(this.props.dialogId == dialogId)
		{
			let dv = new DialogValue();
			dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
			dv.value = $(this.inputField).html();dv.entityId = this.props.data.entityId;
			//alert("DialogFieldStringEditor侦听");
			result[this.props.data.id] = dv;
		}
	}

	componentWillUnmount()
	{
		this.unsubscribeDiaLogMapEditorsStore();
	}

	render()
	{
		let _label = this.state.data.label;
		let _id = this.state.data.id;
		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center',whiteSpace:'pre'};

		let displayLength=this.state.data.displayLength;
		if(displayLength != 0){
			let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';editorStyle.width = _width;
		}
		
		return (
			<div id={"EditorDialog"+_id} className='editorGroup' style={editorStyle}>
		       {_label}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/dialog/DialogFieldLabel.js